// extracted by mini-css-extract-plugin
module.exports = {"container":"detail-module--container--1K08i","content":"detail-module--content--1XJRP","buttons":"detail-module--buttons--31TdB","arrow":"detail-module--arrow--3xmjr"};